import { render, staticRenderFns } from "./ShortText.vue?vue&type=template&id=e5a2cc1e&"
import script from "./ShortText.vue?vue&type=script&lang=js&"
export * from "./ShortText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports